var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYahoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-4h20v20H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    fillRule: "nonzero",
    d: "M4.425 7.478C3.658 6.153 1.405 2.118 0 0l.007.006L.003 0C.71.161 1.008.152 1.718 0l-.004.003L1.72 0c.895 1.586 2.268 3.805 3.429 5.727C6.292 3.847 8.088.913 8.577.002L8.576 0h.002l.002.001c.551.144 1.107.14 1.723 0a1.033 1.033 0 0 0 .001 0L10.3.003C9.648.89 7.293 4.972 5.866 7.476l.003.002L5.972 13l-.827-.39v.013L4.322 13l.103-5.522z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYahoo);
export default __webpack_public_path__ + "static/media/icon-yahoo.602bb942e094610bf287a89e641769bb.svg";
export { ForwardRef as ReactComponent };